import { render, staticRenderFns } from "./PinPurchase.vue?vue&type=template&id=0b530abc&"
import script from "./PinPurchase.vue?vue&type=script&lang=js&"
export * from "./PinPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports